import React, { useEffect, FunctionComponent, JSXElementConstructor } from 'react'
import cx from 'classnames'
import { FLAVOUR_COLORS } from 'constants/flavours'
import tileOverrides from 'constants/tile-overrides'
import TopLevelAccordionContainer from 'redux/containers/components/accordion/TopLevelAccordionContainer'
import useAccordionFound from 'hooks/useAccordionFound'
import { AccordionFoundContainerProps } from 'redux/containers/components/accordion/AccordionFoundContainer'
import { AccordionWrapperProps } from '.'

const AccordionFound: FunctionComponent<AccordionFoundProps> = ({
  aol,
  group,
  eventCategory,
  flavour,
  contained = false,
  SectionHeaderOverride = null,
  section,
  expandedNodeTitle,
  cxNames,
  showAllS1,
  copyright,
  setAccordionIsLoaded,
  isAccordionLoaded,
  legacyClassWrapper = true,
  ...props
}) => {
  const flavourColor = eventCategory === 'Q&A' ? FLAVOUR_COLORS[flavour] : null // FIX ME
  const { borderColor = '', accordionContainer = '' } = cxNames
  const SectionHeaderToUse: JSXElementConstructor<SectionHeaderProps> = SectionHeaderOverride ?? SectionHeader
  const { scrollToRef } = useAccordionFound()

  useEffect(() => {
    setAccordionIsLoaded(true)
    return () => {
      setAccordionIsLoaded(false)
    }
  }, [])

  return (
    <div ref={scrollToRef as unknown as React.RefObject<HTMLDivElement>} className={cx({ 'content-view': legacyClassWrapper, dn: !isAccordionLoaded })}>
      <>
        <Title {...props} />
        <div className={!contained ? 'layout-width-constraint' : ''}>
          <div className={accordionContainer}>
            <SectionHeaderToUse {...{ section, flavourColor, borderColor, expandedNodeTitle }} />
            <TopLevelAccordionContainer {...{ aol, flavourColor, cxNames, showAllS1 }} />
            <div className='sticky' />
            <Footer {...{ copyright }} />
          </div>
        </div>
      </>
    </div>
  )
}

const SectionHeader: FunctionComponent<SectionHeaderProps> = ({ section, expandedNodeTitle, borderColor }) => {
  const header = (expandedNodeTitle !== null && expandedNodeTitle !== '') ? expandedNodeTitle : section
  const append: string | null = tileOverrides.reduce((prev: string | null, val) => {
    if (val.title === header) {
      return val.append
    }
    return prev
  }, null)

  return (
    <div className={cx('ph6 pt7 pb6 bg-white b f3 bb-thick', borderColor)}>
      {header} {append !== null && append !== '' && <span className='pl6 f5'>{append}</span>}
    </div>
  )
}

const Title = ({ styleTitle = true, ...props }): JSX.Element | null => {
  const { title, handleExpandedTitleOnClick } = props

  if (title == null) {
    return null
  }

  // required as we need to pass an onClick handler for when a user clicks the breadcrumb title of an expanded s1 and
  // collapse the s2 accordion and 'navigate' back to the toplevel s1 accordion)
  const titleComponent = React.cloneElement(title, { ...{ handleExpandedTitleOnClick } })

  return (
    <section key='title' className={cx({ 'ma0 bg-white': styleTitle })}>
      <div className={cx({ 'layout-width-constraint': styleTitle })}>
        {titleComponent}
      </div>
    </section>
  )
}

const Footer: FunctionComponent<FooterProps> = ({ copyright }) => copyright !== '' ? <div className='ph8 pt6 f6 lite-grey'>{copyright}</div> : null

interface SectionHeaderProps {
  section: string
  expandedNodeTitle: string | null
  borderColor: string
  flavourColor?: string | null
}

type FooterProps = Pick<AccordionFoundProps, 'copyright'>

type AccordionFoundProps = AccordionFoundContainerProps & AccordionWrapperProps

export default AccordionFound
